import { useState, useEffect } from "react";
import { PassageUser } from "@passageidentity/passage-auth/passage-user";
// import { useSigner } from "./useSigner"

export function useCurrentUser() {
  const [result, setResult] = useState({
    isLoading: true,
    isAuthorized: false,
    username: "",
    p_user_id: "",
    // user_metadata: {},
    re: 0,
  });

  useEffect(() => {
    let cancelRequest = false;
    new PassageUser().userInfo().then((userInfo) => {
      if (cancelRequest) return;

      if (userInfo === undefined) {
        setResult({
          isLoading: false,
          isAuthorized: false,
          username: "",
          // user_metadata: {},
          re: 0,
        });
        return;
      }
      
      setResult({
        isLoading: false,
        isAuthorized: true,
        username: userInfo.email 
          ? userInfo.email 
          : userInfo.phone,
        p_user_id: userInfo.id ?  userInfo.id : "",
        re: userInfo.login_count,
        // user_metadata: userInfo.user_metadata ?  userInfo.user_metadata : {},
      });
      console.log(userInfo)

      // setSigner({
      //   email: userInfo.email ? userInfo.email : "",
      //   phone: userInfo.phone ? userInfo.phone :"",
      // });

    });
    return () => {
      cancelRequest = true;
    };
  }, []);

  return result;
}
